import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-236a861e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-panel"
};
const _hoisted_2 = {
  class: "filter-panel__header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "filter-panel__header-main"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "filter-panel__title"
}, "筛选规则"), /*#__PURE__*/_createElementVNode("p", {
  class: "filter-panel__subtitle"
}, " 配置复合筛选规则以细化您的搜索结果 ")], -1));
const _hoisted_4 = {
  class: "filter-panel__saved"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "filter-panel__saved-label"
}, "已有规则:", -1));
const _hoisted_6 = {
  class: "filter-panel__saved-tags"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "filter-panel__saved-actions"
};
const _hoisted_9 = {
  key: 0,
  class: "filter-panel__divider"
};
const _hoisted_10 = {
  class: "filter-panel__toolbar"
};
const _hoisted_11 = {
  class: "filter-panel__groups"
};
const _hoisted_12 = {
  class: "filter-panel__group"
};
const _hoisted_13 = {
  class: "filter-panel__group-header"
};
const _hoisted_14 = {
  class: "filter-panel__group-title"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "filter-panel__conditions"
};
const _hoisted_17 = {
  class: "filter-panel__condition-fields"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
  class: "filter-panel__group-footer"
};
const _hoisted_20 = ["onClick", "disabled"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "filter-panel__table-slot"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_cascader = _resolveComponent("a-cascader");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _renderSlot(_ctx.$slots, "header-actions", {}, undefined, true)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displaySavedRules, rule => {
    return _openBlock(), _createElementBlock("span", {
      key: rule.templateId || rule.templateName || rule.name || rule.title,
      class: "filter-panel__tag",
      onClick: $event => _ctx.selectSavedRule(rule)
    }, _toDisplayString(rule.templateName || rule.name || rule.title), 9, _hoisted_7);
  }), 128))]), _createElementVNode("div", _hoisted_8, [_ctx.displaySavedRules.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("button", {
    class: "filter-panel__save-button",
    type: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.saveCurrentTemplate && _ctx.saveCurrentTemplate(...args))
  }, " 另存为新模板 ")])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    class: "filter-panel__new-rule-button",
    type: "button",
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.showNextGroup && _ctx.showNextGroup(...args))
  }, " 新增规则 ")]), _ctx.groups.length > 0 ? (_openBlock(), _createBlock(_component_a_tabs, {
    key: 0,
    activeKey: _ctx.activeGroupKey,
    "onUpdate:activeKey": _cache[2] || (_cache[2] = $event => _ctx.activeGroupKey = $event),
    class: "filter-panel__tabs",
    animated: false,
    onChange: _ctx.handleTabChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, groupIndex) => {
      return _openBlock(), _createBlock(_component_a_tab_pane, {
        key: String(group.id),
        tab: `规则 ${groupIndex + 1}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("article", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, "(GROUP) " + _toDisplayString(groupIndex + 1), 1), _createElementVNode("button", {
          class: "filter-panel__icon-button",
          type: "button",
          "aria-label": "删除分组",
          onClick: $event => _ctx.removeGroup(group.id)
        }, [_createVNode(_component_DeleteOutlined)], 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.conditions, condition => {
          return _openBlock(), _createElementBlock("div", {
            key: condition.id,
            class: "filter-panel__condition"
          }, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_a_select, {
            value: condition.field,
            "onUpdate:value": $event => condition.field = $event,
            class: "filter-panel__field",
            options: _ctx.getAvailableFieldOptions(group.id, condition.id),
            "get-popup-container": _ctx.getPopupContainer,
            onChange: $event => _ctx.onFieldChange(condition, $event)
          }, null, 8, ["value", "onUpdate:value", "options", "get-popup-container", "onChange"]), _createVNode(_component_a_select, {
            value: condition.operator,
            "onUpdate:value": $event => condition.operator = $event,
            class: "filter-panel__operator",
            options: _ctx.operatorOptions,
            "get-popup-container": _ctx.getPopupContainer
          }, null, 8, ["value", "onUpdate:value", "options", "get-popup-container"]), _ctx.isTextField(condition.field) ? (_openBlock(), _createBlock(_component_a_input, {
            key: `${condition.id}-input-${condition.field}`,
            value: condition.value,
            "onUpdate:value": $event => condition.value = $event,
            class: "filter-panel__value"
          }, null, 8, ["value", "onUpdate:value"])) : _ctx.isCityField(condition.field) ? (_openBlock(), _createBlock(_component_a_cascader, {
            key: `${condition.id}-city-${condition.field}`,
            value: condition.value,
            "onUpdate:value": $event => condition.value = $event,
            class: "filter-panel__value",
            multiple: "",
            "allow-clear": "",
            options: _ctx.cityCascaderOptions,
            "show-search": true,
            "get-popup-container": _ctx.getPopupContainer,
            placeholder: "请选择省市"
          }, null, 8, ["value", "onUpdate:value", "options", "get-popup-container"])) : (_openBlock(), _createBlock(_component_a_select, {
            key: `${condition.id}-select-${condition.field}`,
            value: condition.value,
            "onUpdate:value": $event => condition.value = $event,
            class: "filter-panel__value",
            mode: "multiple",
            "allow-clear": "",
            "show-search": "",
            "option-filter-prop": "label",
            "filter-option": _ctx.filterSelectOption,
            options: _ctx.getFieldValueOptions(condition.field),
            "get-popup-container": _ctx.getPopupContainer
          }, null, 8, ["value", "onUpdate:value", "filter-option", "options", "get-popup-container"]))]), group.conditions.length > 1 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "filter-panel__condition-remove",
            type: "button",
            "aria-label": "删除条件",
            onClick: $event => _ctx.removeCondition(group.id, condition.id)
          }, [_createVNode(_component_DeleteOutlined)], 8, _hoisted_18)) : _createCommentVNode("", true)]);
        }), 128))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
          class: "filter-panel__add-button",
          type: "button",
          onClick: $event => _ctx.addCondition(group.id),
          disabled: !_ctx.hasAvailableFields(group.id)
        }, " + 添加条件 ", 8, _hoisted_20), _createElementVNode("button", {
          class: "filter-panel__apply-button",
          type: "button",
          onClick: $event => _ctx.applyGroup(group)
        }, " 搜索 / 应用 ", 8, _hoisted_21)])]), _createElementVNode("div", _hoisted_22, [_renderSlot(_ctx.$slots, "group-table", {
          group: _ctx.buildGroupPayload(group),
          groupIndex: groupIndex
        }, undefined, true)])])]),
        _: 2
      }, 1032, ["tab"]);
    }), 128))]),
    _: 3
  }, 8, ["activeKey", "onChange"])) : _createCommentVNode("", true)]);
}